// Toggle.tsx
import React from "react";
import styled from "styled-components";

type ToggleProps = {
  checked: boolean;
  onChange: () => void;
};

const StyledToggle = styled.div.attrs({ className: "checkbox-toggle" })`
  .card-toggle-color {
    background-color: #d7d7d8;
  }

  .form-switch .form-check-input {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%2386888B'/%3e%3c/svg%3e");
  }

  .card-toggle-color:checked {
    background-color: ${(props) => props.theme.primaryColor}; // Assuming you have a theme with a primaryColor
    border-color: ${(props) => props.theme.primaryColor};
  }

  .card-toggle-color:focus {
    border-color: ${(props) => props.theme.primaryColor};
    box-shadow: ${(props) => `0 0 3px 2px ${props.theme.primaryColor}`};
  }

  .form-switch .form-check-input:checked {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e");
  }
`;

const Toggle: React.FC<ToggleProps> = ({ checked, onChange }: ToggleProps) => {
  return (
    <StyledToggle>
      <div className="form-check form-switch">
        <input className="form-check-input card-toggle-color" type="checkbox" id="flexSwitchCheckDefault" checked={checked} onChange={onChange} />
      </div>
    </StyledToggle>
  );
};

export default Toggle;
